import defaultValues from "@/constant/defaultValues";
import { isEmpty, lowerCase } from "lodash";
import { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const DAPFreight = (props) => {
  const { DAP_SERVICE_TYPE, CONTAINER_TYPE } = defaultValues;

  const {
    errors,
    styleError,
    selectedOceanType,
    handleOceanTypeChange,
    handleFocusOut,
    handlePortOfOriginChange,
    countries,
    selectedCountryFrom,
    handleCountryFromChange,
    handleOriginPortInputChange,
    portOfOriginList,
    selectedPortOfOrigin,
    validatePortInput,
    originLoader,
    formData,
    handleChange,
    selectedCbpp,
    handleCbppTypeChange
  } = props;

  const [nocPlaceholder, setNocPlaceholder] = useState("No of Containers");
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  useEffect(() => {
    if (selectedOceanType) {
      if (selectedOceanType.value === "FCL" || selectedOceanType.value === "DAG_GOODS") {
        setNocPlaceholder("No of Containers *");
      } else if (selectedOceanType.value === "LCL") {
        setNocPlaceholder("No of Containers");
      } else if (selectedOceanType.value === "Ro-Ro") {
        setNocPlaceholder("No of Units");
      } else if (selectedOceanType.value === "Project_Cargo") {
        setNocPlaceholder("No of pieces *");
      }
    }
  }, [selectedOceanType]);

  return (
    <>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div
          className={`input-wrape select-wrape ${errors.ocean_type ? "error-show" : ""}`}
          style={{
              position: "relative",
              zIndex: openMenuIndex === "cargo" ? 10 : 1
            }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="ocean_type"
              options={DAP_SERVICE_TYPE}
              value={selectedOceanType}
              onChange={handleOceanTypeChange}
              placeholder="Select cargo type *"
              className="select"
              noOptionsMessage={() => "No cargo type Found"}
              onBlur={handleFocusOut}
              classNamePrefix={"Drop-down-menu"}
              onMenuOpen={() => setOpenMenuIndex("cargo")}
              onMenuClose={() => setOpenMenuIndex(null)}
            />
            {errors.ocean_type && (
              <span className="invalid-feedback" style={styleError}>
                {errors.ocean_type}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-12">
        <hr className="mt-0" />
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.country_from ? "error-show" : ""}`}
          style={{ zIndex: "9" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select country *"
              className="select"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
              classNamePrefix={"Drop-down-menu"}
            />
            {errors.country_from && (
              <span className="invalid-feedback" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.port_of_origin ? "error-show" : ""}`}

          style={{
            position: "relative",
            zIndex: openMenuIndex === "port" ? 10 : 1
          }}
        >
          <div className="input-pad">
            <CreatableSelect
              name="port_of_origin"
              onChange={handlePortOfOriginChange}
              onInputChange={handleOriginPortInputChange}
              options={portOfOriginList}
              value={selectedPortOfOrigin}
              classNamePrefix={"creatable_react_select Drop-down-menu"}
              placeholder={`Enter port *`}
              onMenuOpen={() => setOpenMenuIndex("port")}
              onMenuClose={() => setOpenMenuIndex(null)}
              formatCreateLabel={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                if (
                  validationError ||
                  validatePortInput(inputValue) ||
                  isEmpty(inputValue)
                ) {
                  return;
                }
                return `Create "${inputValue}"`;
              }}
              isValidNewOption={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                return validationError === null;
              }}
              isLoading={originLoader}
            />

            {errors.port_of_origin && (
              <span className="invalid-feedback" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.commodity ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="commodity"
              value={formData.commodity}
              className="input"
              autoComplete="off"
              placeholder={selectedOceanType && selectedOceanType.value == "Ro-Ro" ? "Enter commodity /  product *" : "Enter commodity *"}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="invalid-feedback" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.hs_code ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="hs_code"
              value={formData.hs_code}
              className="input"
              autoComplete="off"
              placeholder="Enter Hs Code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="invalid-feedback" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.no_of_containers ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="no_of_containers"
              value={formData.no_of_containers}
              className="input"
              autoComplete="off"
              placeholder={nocPlaceholder}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.no_of_containers && (
              <span className="invalid-feedback" style={styleError}>
                {errors.no_of_containers}
              </span>
            )}
          </div>
        </div>
      </div>
      {
        selectedOceanType && selectedOceanType.value == "FCL" && <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <div
            className={`input-wrape select-wrape ${errors.cbpp ? "error-show" : ""}`}
            style={{
              position: "relative",
              zIndex: openMenuIndex === "cbpp" ? 10 : 1
            }}
          >
            <div className="input-pad select-wrape">
              <Select
                name="cbpp"
                options={CONTAINER_TYPE}
                value={selectedCbpp}
                onChange={handleCbppTypeChange}
                placeholder="Select Type of Container *"
                className="select"
                onBlur={handleFocusOut}
                noOptionsMessage={() => "No Container Found"}
                classNamePrefix={"Drop-down-menu"}
                onMenuOpen={() => setOpenMenuIndex("cbpp")}
                onMenuClose={() => setOpenMenuIndex(null)}
              />
              {errors.cbpp && (
                <span className="invalid-feedback" style={styleError}>
                  {errors.cbpp}
                </span>
              )}
            </div>
          </div>
        </div>}
      {selectedOceanType && (selectedOceanType.value == "LCL" || selectedOceanType.value == "DAG_GOODS" || selectedOceanType.value == "Project_Cargo") && <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.cbpp ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="cbpp"
              value={formData.cbpp}
              className="input"
              autoComplete="off"
              placeholder={`Enter Type of Packaging ${selectedOceanType.value == "Project_Cargo" ? "" : "*"}`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.cbpp && (
              <span className="invalid-feedback" style={styleError}>
                {errors.cbpp}
              </span>
            )}
          </div>
        </div>
      </div>
      }

      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.total_weight ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="total_weight"
              value={formData.total_weight}
              className="input"
              autoComplete="off"
              placeholder="Enter total weight (kg)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.total_weight && (
              <span className="invalid-feedback" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.delivery_address ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="delivery_address"
              value={formData.delivery_address}
              className="input"
              autoComplete="off"
              placeholder="Enter delivery address *"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.delivery_address && (
              <span className="invalid-feedback" style={styleError}>
                {errors.delivery_address}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DAPFreight;
